import { ModuleWithProviders, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { MatPaginatorModule } from '@angular/material/paginator';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import {DragDropModule} from '@angular/cdk/drag-drop';

// Material
import {
	MatButtonModule,
	MatCheckboxModule,
	MatFormFieldModule,
	MatInputModule,
} from "@angular/material";
// Translate
import { TranslateModule } from "@ngx-translate/core";
// NGRX
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
// CRUD
import { InterceptService } from "../../../core/_base/crud/";

// import{UserloginComponent} from '../userlogin/userlogin.component';
import { from } from "rxjs";

import { WidgetDashboardComponent } from "./widget-dashboard/widget-dashboard.component";
import { BlankLayoutComponent } from "./blank-layout/blank-layout.component";
import { PartialsModule } from "../../partials/partials.module";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { MatTabsModule } from "@angular/material/tabs";
import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import {MatSidenavModule} from '@angular/material/sidenav';
import { CoreModule } from "../../../core/core.module";
import {MatCardModule} from '@angular/material/card';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatDividerModule} from '@angular/material/divider';
import { HeaderWidgetComponent } from './widget-dashboard/header-widget/header-widget.component';
import { SideNavWidgetComponent } from './widget-dashboard/side-nav-widget/side-nav-widget.component';
import { SubModuleWidgetComponent } from './widget-dashboard/sub-module-widget/sub-module-widget.component';
import { LandingPageWidgetComponent } from './widget-dashboard/landing-page-widget/landing-page-widget.component';
import {MatListModule} from '@angular/material/list';
import { WidgetDetailsComponent } from './widget-dashboard/widget004-details/widget-details.component';
import { Widget0004Component } from './widget-dashboard/widget0004/widget0004.component';
import { FileAttachDetailComponent } from './widget-dashboard/FileAttachDetail/file-attach-detail.component';
import { GreetingsListComponent } from './widget-dashboard/GreetingList//greetings-list.component';
import { Tsk5020NewComponent } from "../Hrms/TSK5020/New/tsk5020-new.component";
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgbAlertConfig, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MaterialPreviewModule } from '../../partials/content/general/material-preview/material-preview.module';
import { HttpClientModule } from '@angular/common/http';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import {
	MatProgressSpinnerModule,
	MatSortModule,
	MatTableModule,
	MatSelectModule,
	MatProgressBarModule,
	MatDialogModule,
	MatNativeDateModule,
	MatRadioModule,
	MatDatepickerModule,
	MatAutocompleteModule,
	MAT_DIALOG_DEFAULT_OPTIONS,
	MatSnackBarModule,
	DateAdapter,
	MAT_DATE_LOCALE,
	MAT_DATE_FORMATS
} from '@angular/material';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { WebcamModule } from 'ngx-webcam';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { SharedTaskModule } from '../../../../app/shared/shared-task/shared-task.module';

//CSP Imports
import { Csp5010ViewComponent } from "../CSP/CSPViews/csp5010-view/csp5010-view.component";
import { Csp5020ViewComponent } from "../CSP/CSPViews/csp5020-view/csp5020-view.component";
import { Csp5030ViewComponent } from "../CSP/CSPViews/csp5030-view/csp5030-view.component";
import { Csp5040ViewComponent } from "../CSP/CSPViews/csp5040-view/csp5040-view.component";
import { Csp5050ViewComponent } from "../CSP/CSPViews/csp5050-view/csp5050-view.component";
import { Csp5060ViewComponent } from "../CSP/CSPViews/csp5060-view/csp5060-view.component";
import { Csp5070ViewComponent } from "../CSP/CSPViews/csp5070-view/csp5070-view.component";
import { Csp5080ViewComponent } from "../CSP/CSPViews/csp5080-view/csp5080-view.component";
import { Csp5090ViewComponent } from "../CSP/CSPViews/csp5090-view/csp5090-view.component";
import { UserProfileComponent } from "../../partials/layout/topbar/user-profile/user-profile.component";
import { Ba1110ChangeComponent } from "../Hrms/ba1110/Change/ba1110-change.component";

const routes: Routes = [
	{
		path: "",
		component: WidgetDashboardComponent,
		children: [
			{
				path: "",
				redirectTo: "landing",
				pathMatch: "full",
			},
			// {
			// 	path: "widget-dashboard",
			// 	component: WidgetDashboardComponent,
			// },
			{
				path: "widget-dashboard/:id",
				component: SubModuleWidgetComponent,
			},
			{
				path: "landing",
				component: LandingPageWidgetComponent,
			},
			{
				path: "widget-dashboard/:id",
				component: WidgetDetailsComponent,
			},
			{
				path: "widget-dashboard/:id",
				component: Widget0004Component,
			},
			{
				path: "widget-dashboard/:id",
				component: FileAttachDetailComponent,
			},
			{
				path: "widget-dashboard/:id",
				component: GreetingsListComponent,
			},
			
	
		],
	},
];

@NgModule({
	declarations: [
		WidgetDashboardComponent,
		BlankLayoutComponent,
		HeaderWidgetComponent,
		SideNavWidgetComponent,
		SubModuleWidgetComponent,
		LandingPageWidgetComponent,
		WidgetDetailsComponent,
		Widget0004Component,
		FileAttachDetailComponent,
		GreetingsListComponent,

		Csp5010ViewComponent,
        Csp5020ViewComponent,
        Csp5030ViewComponent,
        Csp5040ViewComponent,
        Csp5050ViewComponent,
        Csp5060ViewComponent,
        Csp5070ViewComponent,
        Csp5080ViewComponent,
        Csp5090ViewComponent
	],

	exports: [
		HeaderWidgetComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatButtonModule,
		RouterModule.forChild(routes),
		MatInputModule,
		MatFormFieldModule,
		MatCheckboxModule,
		TranslateModule.forChild(),
		PartialsModule,
		NgbTooltipModule,
		MatTabsModule,
		MatMenuModule,
		MatIconModule,
		MatSidenavModule,
		CoreModule,
		MatCardModule,
		MatExpansionModule,
		MatDividerModule,
		MatListModule,
		MatPaginatorModule,
		MatTooltipModule,

				SelectDropDownModule,
				CommonModule,
				PartialsModule,
				NgbModule,
				CoreModule,
				MaterialPreviewModule,
				RouterModule.forChild(routes),
				FormsModule,
				ReactiveFormsModule,
				HttpClientModule,
				PerfectScrollbarModule,
		
				MatButtonModule,
				MatMenuModule,
				MatSelectModule,
				MatInputModule,
				MatTableModule,
				MatAutocompleteModule,
				MatRadioModule,
				MatIconModule,
				MatNativeDateModule,
				MatProgressBarModule,
				MatDatepickerModule,
				MatCardModule,
				MatPaginatorModule,
				MatSortModule,
				MatCheckboxModule,
				MatProgressSpinnerModule,
				MatSnackBarModule,
				MatExpansionModule,
				MatTabsModule,
				MatTooltipModule,
				MatDialogModule,
				CKEditorModule,
				WebcamModule,
				FroalaEditorModule,
				FroalaViewModule,
				MatButtonToggleModule,
				DragDropModule,
				SharedTaskModule
	
	],
	providers: [],
	entryComponents: [
			Tsk5020NewComponent,
			Csp5010ViewComponent,
			Csp5020ViewComponent,
			Csp5030ViewComponent,
			Csp5040ViewComponent,
			Csp5050ViewComponent,
			Csp5060ViewComponent,
			Csp5070ViewComponent,
			Csp5080ViewComponent,
			Csp5090ViewComponent
			// UserProfileComponent
		]
})
export class WidgetModule {}
